module.exports = __webpack_public_path__ + "static/about-figures-2-2a3cb167ef64261e90221dae7e4319c8.png";